module.exports = __webpack_public_path__ + "static/media/SCBcard.cef782b7.svg";